import './typing_effect.js';
import './smooth_scrolling.js';
import './banner.js'
import './form_obfs.js';
import './form.js';
import './navigation.js';
import './dynamic_hero.js';
import './modal.js'